import React from 'react';
import { IntlProvider } from '../../util/reactIntl';
import enMessages from '../../translations/en.json';
import css from './EnglishScope.module.css';

const EnglishScope = ({ children }) => {
  return (
    <div className={css.root} dir="ltr" lang="en">
      <IntlProvider locale="en" messages={enMessages} textComponent="span">
        {children}
      </IntlProvider>
    </div>
  );
};

export default EnglishScope;
